import React, { useContext, useState, useEffect } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {
  AppBar,
  Toolbar,
  IconButton,
  Hidden,
  Box,
  Badge,
  Avatar,
  Typography,
  SvgIcon,
} from '@mui/material';
import { styled } from "@mui/system";
import { Menu as MenuIcon } from "react-feather";
import { useHistory } from "react-router-dom";
import { AuthContext } from "src/context/Auth";
import { useDispatch, useSelector } from 'react-redux';
import { FetchApiSlice } from 'src/service/ThunkApiCall/FetchApiSlice';
import { selectProfile } from 'src/service/Fetures/ProfileSlice';
import LogoutModal from "src/component/LogoutModal";
const StyledDashboard = styled("Box")(({ theme }) => ({
  "& .root": {
    // backgroundColor: theme.palette.primary.paper,
    "& .MuiPaper-root": {},
  },
  "& .timechange": {
    marginLeft: "250px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px",
    },
    "h4": {
      fontWeight: 700,
      fontFamily: "monospace",
      background: " #22242a",
      padding: "10px 20px",
      borderRadius: " 10px",
    }
  },
  "& .toolbar": {
    height: 80,
    padding: "0 20px",
    background: "#282b33f0",
    boxShadow: "rgb(90 114 123 / 11%) 0px 7px 30px 0px",
    backdropFilter: "blur(44px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.only("xs")]: {
      padding: "0 10px",
    },

  },
  "& .muilistover .MuiListItem-root": {
    cursor: "pointer",
    "&:hover": {
      color: "#ffbb55 !important",
    },
  },
  "& .logo": {
    marginRight: theme.spacing(2),
  },
  "& .link": {
    fontWeight: theme.typography.fontWeightMedium,
    "& + &": {
      marginLeft: theme.spacing(2),
    },
  },
  "& .divider": {
    width: 1,
    height: 32,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  "& .MuiBadge-badge": {
    display: "flex",
    bottom: "11%",
    right: "5%",
  }
}));

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 15,
  height: 15,

}));

const TopBar = ({ className, onMobileNavOpen, ...rest }) => {

  const history = useHistory();
  const auth = useContext(AuthContext);


  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!window.localStorage.getItem("token")) {
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("userType");
      history.push("/")
    }
  }, [window.localStorage.getItem("token")]);
  const getObjdata = window.localStorage.getItem("empdata");
  const parsedData = JSON.parse(getObjdata);

  const currentTime1 = moment().format('YYYY-MM-DD');
  const loginTime = window.localStorage.getItem("loginTime");

  useEffect(() => {
    if (window.localStorage.getItem("token")) {
      if (moment(loginTime).unix() < moment(currentTime1).unix()) {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("userType");
        window.localStorage.removeItem("userID");
        window.localStorage.removeItem("empdata");
        window.localStorage.removeItem("auth")
        window.localStorage.removeItem("loginTime")
      }
    }
  }, [window.localStorage.getItem("token")]);

  const [open5, setOpen5] = useState(false);
  const dispatch = useDispatch();
  const { status, data, error } = useSelector(selectProfile);
  useEffect(() => {
    dispatch(FetchApiSlice());
  }, [dispatch]);
  const logoutHandler = () => {
    history.push("/");
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("userType");
    window.localStorage.removeItem("userID");
    window.localStorage.removeItem("empdata");
    window.localStorage.removeItem("auth")
    window.localStorage.removeItem("loginTime")
  };
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  // const id = open ? 'simple-popover' : undefined;
  return (
    <StyledDashboard>
      <AppBar className="root" color="default" {...rest}>
        <Toolbar className="toolbar">
          {/* <Hidden lgUp> */}
          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <SvgIcon fontSize="40px">
              <MenuIcon style={{ color: "#fff" }} />
            </SvgIcon>
          </IconButton>
          <Box className="timechange">
            <Typography variant="h4">
              {moment(currentTime).format('h : mm : ss a')}
            </Typography>
          </Box>
          {/* </Hidden> */}
          {/* <Hidden lgDown> */}
          <Box display="flex" alignItems="center">
            <Box mr={2} style={{ textAlign: "right" }}>
              <Typography variant="h6">
                {data && data?.firstName ? data?.firstName : "..."}
              </Typography>
              {parsedData !== null && (
                <>
                  <Typography variant="h6" style={{
                    background: "rgb(120 197 79)",
                    padding: "0px 10px",
                    borderRadius: "5px"
                  }}>
                    <span style={{ fontSize: "14px", color: " #000", }}>Punched In :- </span>
                    <span style={{
                      fontSize: "14px",
                      color: " #000",
                      fontWeight: 700
                    }}>{parsedData.punchIntime}</span>
                  </Typography>
                </>
              )}
            </Box>
            <IconButton onClick={handleClick}>
              {/* <Badge className="namePlace" color="secondary">
                <Avatar
                  src={data && data.imageurl}
                />
              </Badge> */}
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                badgeContent={
                  <SmallAvatar alt="Remy Sharp" src="images/verified.png" />
                }
              >
                <Box className="avatar_css">
                  <Avatar alt="Travis Howard" src={data && data.imageurl} />
                </Box>
              </Badge>
            </IconButton>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem onClick={() => history.push(`${"/Profile"}?${data._id}`)}>Profile</MenuItem>
              {/* <MenuItem onClick={handleClose}>My account</MenuItem> */}
              <MenuItem onClick={() => { setOpen5(true); handleClose(); }}>Logout</MenuItem>
            </Menu>
          </Box>
          {/* </Hidden> */}
        </Toolbar>
      </AppBar>
      {open5 && (
        <LogoutModal
          open5={open5}
          title="Are you sure want to logout ?"
          handleClose={() => setOpen5(false)}
          logoutHandler={logoutHandler}
        />
      )}
    </StyledDashboard>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
};
TopBar.defaultProps = {
  onMobileNavOpen: () => { },
};

export default TopBar;
